import React from 'react';

/**
 * SVG Circular Progress Ring for Confidence Score
 * Design: Fintech-grade, clean, orange accent
 */
const ConfidenceRing = ({ percentage = 0, size = 130, strokeWidth = 10 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  // Color based on confidence level
  const getColor = (pct) => {
    if (pct >= 80) return '#10B981'; // emerald
    if (pct >= 60) return '#F5A623'; // gold/orange
    if (pct >= 40) return '#F59E0B'; // amber
    return '#EF4444'; // red
  };

  const color = getColor(percentage);

  return (
    <div data-testid="confidence-ring" style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        {/* Background track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#F1F5F9"
          strokeWidth={strokeWidth}
        />
        {/* Progress arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.8s ease-in-out, stroke 0.5s ease' }}
        />
      </svg>
      {/* Center text */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '28px', fontWeight: '700', color: '#0F172A', fontFamily: 'Poppins, sans-serif' }}>
          {percentage}%
        </div>
        <div style={{ fontSize: '10px', fontWeight: '600', color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
          Confidence
        </div>
      </div>
    </div>
  );
};

export default ConfidenceRing;
